import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, TextField, Grid, Paper, MenuItem, Typography, IconButton, InputAdornment, Autocomplete, Modal, Box } from "@mui/material";
import PrintIcon from "@mui/icons-material/Print";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ClearIcon from "@mui/icons-material/Clear";
import SearchIcon from "@mui/icons-material/Search";
import PaymentIcon from '@mui/icons-material/Payment';
import CloseIcon from '@mui/icons-material/Close';
import Swal from "sweetalert2";
import api from "../../api";
//import axios from 'axios';


const StudentBill = () => {
    const [user, setUser] = useState(null);
    const navigate = useNavigate();
    const [isSidebarOpen, setIsSidebarOpen] = useState(true);
    const [sessions, setSessions] = useState([]);
    const [filters, setFilters] = useState({
        session: null
    });
    const [classList, setClassList] = useState([]);
    const [sections, setSections] = useState([]);
    const [rolls, setRolls] = useState([]);
    const [selectedClass, setSelectedClass] = useState([]);
    const [selectedSection, setSelectedSection] = useState([]);
    const [selectedRoll, setSelectedRoll] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [student, setStudent] = useState(null);
    const [fees, setFees] = useState([]);
    const [openModal, setOpenModal] = useState(false);
    const [selectedFee, setSelectedFee] = useState(null);
    const [paidFees, setPaidFees] = useState([]);
    const [payments, setPayments] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [paymentMode, setPaymentMode] = useState("");
    const [utrNumber, setUtrNumber] = useState("");
    const [totalDays, setTotalDays] = useState(0);
    const [filteredFees, setFilteredFees] = useState([]);
    const schoolId = localStorage.getItem("school_id");

    const sessionName = filters.session?.session_name || ""; // "2025-26"

    let startYear = null;

    if (sessionName.includes("-")) {
        startYear = parseInt(sessionName.split("-")[0], 10); // 2025
    }

    const getAcademicMonth = (monthId, session) => {
        if (!session?.session_name) return null;

        const startYear = parseInt(session.session_name.split("-")[0], 10);

        return `${startYear}-${monthId}`;
    };


    useEffect(() => {
        const token = localStorage.getItem("token");
        const storedUser = {
            id: localStorage.getItem("id"),
            user_id: localStorage.getItem("user_id"),
            name: localStorage.getItem("name"),
            mobile: localStorage.getItem("mobile"),
            role: localStorage.getItem("role"),

        };

        if (!token) {
            navigate("/login");
        } else {
            setUser(storedUser);
        }
    }, []);

    // 🧩 Init
    useEffect(() => {
        fetchSessions();
    }, []);

    // 🧩 Fetch Sessions
    const fetchSessions = async () => {
        try {
            const res = await api.get("school/academic_year/list", {
                headers: { "X-School-Id": schoolId },
            });

            if (res.data?.status !== false) {
                const data = res.data.data || [];
                data.sort((a, b) => (a.status === "active" ? -1 : 1));
                setSessions(data);

                // Auto-select active session
                if (!filters.session && data.length) {
                    const active = data.find((s) => s.status === "active");
                    setFilters((p) => ({ ...p, session: active || data[0] }));
                }
            }
        } catch {
            Swal.fire("Error", "Failed to fetch sessions", "error");
        }
    };

    const handleSubmit = async () => {
        if (isSubmitting) return; // 🔒 Prevent double-click immediately

        if (!selectedFee || !paymentMode) {
            Swal.fire({ icon: "warning", title: "Oops...", text: "Please select a payment mode!" });
            return;
        }

        setIsSubmitting(true); // 🟢 Lock button

        try {
            let feeType = selectedFee.id;
            let amount = selectedFee.amount;

            if (selectedFee.fee_type.includes("Monthly Fees")) {
                feeType = "monthly_fees";
            }

            const monthId = selectedFee?.month_id
                ? selectedFee.month_id
                : (new Date().getMonth() + 1).toString().padStart(2, "0");

            const formattedMonth = getAcademicMonth(monthId, filters.session);

            const paymentData = {
                school_id: schoolId,
                academic_year_id: filters.session?.id,
                student_id: selectedFee.student_id || student.id,
                class_id: selectedFee.class_id ?? student.class_id ?? null,
                fee_type: feeType,
                amount,
                payment_mode: paymentMode,
                utr_number: paymentMode === "upi" ? (utrNumber || "") : "",
                collected_by: user?.id,
                payment_month: formattedMonth // yearly হলে month বাদ
            };

            console.log("📤 Sending paymentData:", paymentData);

            const res = await api.post("/student-payment", paymentData);

            if (res?.data?.status) {
                Swal.fire({
                    icon: "success",
                    title: "Payment Successful",
                    text: `₹ ${amount} has been paid successfully!`,
                    confirmButtonColor: "#3f51b5",
                });

                setOpenModal(false);
                setPaymentMode("");
                setUtrNumber("");

                // ✅ paidFees update
                if (feeType === "monthly_fees") {
                    const paidId = `monthly_fees_${parseInt(monthId, 10)}`;
                    setPaidFees(prev => (prev.includes(paidId) ? prev : [...prev, paidId]));
                } else {
                    const ft = String(selectedFee.id);
                    setPaidFees(prev => (prev.includes(ft) ? prev : [...prev, ft]));
                }
            } else {
                throw new Error(res?.data?.message || "Payment failed. Please try again.");
            }
        } catch (err) {
            console.error("❌ Payment error:", err);
            Swal.fire({
                icon: "error",
                title: "Payment Failed",
                text: err?.response?.data?.message || err?.message || "Something went wrong.",
            });
            setOpenModal(false);
        } finally {
            setIsSubmitting(false); // 🔓 Unlock button after completion
        }
    };

    const handleOpenModal = (fee, student, monthId = null) => {
        setSelectedFee({ ...fee, student_id: student?.id, class_id: student?.class_id, month_id: monthId }); // ✅ student_id যোগ করা হলো
        setOpenModal(true);
    };

    const handleCloseModal = () => {
        setOpenModal(false);
        setSelectedFee(null);
    };
    const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

    const selectStyles = {
        control: (provided) => ({
            ...provided,
            height: 56, // Same as MUI TextField
            minHeight: 56,
            backgroundColor: "#ffffff", // White background
        }),
        menu: (provided) => ({
            ...provided,
            backgroundColor: "#ffffff", // Dropdown menu background white
            zIndex: 1000,
        }),
    };

    const handlePrint = async (studentId, feeType, category, monthId = null) => {
        try {
            let res;

            if (category !== "monthly") {
                res = await api.get(`student-invoice/${studentId}/${feeType}/${filters.session?.id}`);
            } else {
                const finalMonthId = monthId
                    ? monthId
                    : (new Date().getMonth() + 1).toString().padStart(2, "0");

                const formattedMonth = getAcademicMonth(finalMonthId, filters.session);
                res = await api.get(`student-invoice/${studentId}/${formattedMonth}/${filters.session?.id}`);
            }

            if (res.data.status) {
                const data = res.data.data;

                const printWindow = window.open();

                // helper to get school info for print
                function getPrintSchoolInfo(apiData) {
                    const LOGO_BASE = "https://dgps.co.in/public/admin/assets/img/schools/logo";
                    const defaultLogo = "https://dgps.co.in/public/admin/assets/img/logo.png";

                    const resolveLogo = (logo) => {
                        if (!logo) return defaultLogo;
                        if (/^https?:\/\//i.test(logo) || logo.startsWith("data:")) return logo;
                        return `${LOGO_BASE}/${logo.replace(/^\/+/, "")}`;
                    };

                    // First prefer API-provided fields (apiData is res.data.data)
                    if (apiData && (apiData.school_name || apiData.school_logo || apiData.school_address || apiData.school_phone || apiData.school_email)) {
                        return {
                            name: (apiData.school_name || "Dormant Garden Public School").toUpperCase(),
                            address: apiData.school_address || "",
                            phone: apiData.school_phone || "",
                            email: apiData.school_email || "",
                            logo: resolveLogo(apiData.school_logo),
                            defaultLogo
                        };
                    }

                    // Fallback to localStorage (same logic as Header component)
                    try {
                        const rawSchools = localStorage.getItem("schools");
                        const savedSchoolId = localStorage.getItem("school_id");
                        if (rawSchools) {
                            const parsed = JSON.parse(rawSchools);
                            const chosen = parsed.find((s) => String(s.id) === String(savedSchoolId)) || parsed[0];
                            if (chosen) {
                                return {
                                    name: (chosen.name || "Dormant Garden Public School").toUpperCase(),
                                    address: chosen.address || "",
                                    phone: chosen.phone || "",
                                    email: chosen.email || "",
                                    logo: resolveLogo(chosen.logo),
                                    defaultLogo
                                };
                            }
                        }
                        const sname = localStorage.getItem("school_name");
                        const slog = localStorage.getItem("school_logo");
                        return {
                            name: (sname || "Dormant Garden Public School").toUpperCase(),
                            address: localStorage.getItem("school_address") || "",
                            phone: localStorage.getItem("school_phone") || "",
                            email: localStorage.getItem("school_email") || "",
                            logo: resolveLogo(slog),
                            defaultLogo
                        };
                    } catch (err) {
                        return {
                            name: "Dormant Garden Public School",
                            address: "",
                            phone: "",
                            email: "",
                            logo: defaultLogo,
                            defaultLogo
                        };
                    }
                }

                const school = getPrintSchoolInfo(data);

                printWindow.document.write(`
              <html>
                <head>
                  <title>Fee Receipt</title>
                  <style>
                    body {
                      font-family: 'Segoe UI', sans-serif;
                      margin: 0;
                      padding: 20px;
                      background: #f4f6f9;
                    }
      
                    .receipt-box {
                      background: #fff;
                      border: 2px dashed #ccc;
                      border-radius: 12px;
                      padding: 10px;
                      margin: 20px;
                      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
                      margin-bottom: 50px;
                    }
      
                    .school-header {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        gap: 10px;
                    }

                    .school-text {
                        flex-grow: 1;
                        text-align: center;
                    }

      
                    .school-logo {
                      width: 90px;
                      height: 90px;
                      object-fit: contain;
                    }
      
                    .school-name {
                      font-size: 22px;
                      font-weight: bold;
                      color: #002f6c;
                    }
      
                    .school-contact {
                      font-size: 12px;
                      color: #444;
                    }
      
                    .header {
                      background: #002f6c;
                      color: #fff;
                      text-align: center;
                      font-size: 20px;
                      font-weight: bold;
                      padding: 10px;
                      border-radius: 5px 5px 0 0;
                      
                    }
      
                    .copy-label {
                      text-align: center;
                      font-size: 12px;
                      color: #888;
                      margin: 10px 0 20px;
                    }
      
                    .section-title {
                      text-align: center;
                      font-weight: bold;
                      font-size: 16px;
                      margin: 20px 0 10px;
                      color: #002f6c;
                      border-bottom: 1px solid #ccc;
                      padding-bottom: 5px;
                    }
      
                    .info-row.single-row {
                      display: flex;
                      justify-content: space-between;
                      align-items: center;
                      flex-wrap: nowrap;
                    }
      
                    .info-row.single-row p {
                      width: auto;
                      margin-right: 30px;
                      white-space: nowrap;
                      font-size: 14px;
                    }
      
                    .info-row {
                      display: flex;
                    }
      
                    .info-row p {
                      font-size: 14px;
                      margin: 5px 0;
                      width: 48%;
                    }
      
                    table {
                      width: 100%;
                      border-collapse: collapse;
                      margin-top: 15px;
                    }
      
                    th, td {
                      border: 1px solid #ccc;
                      padding: 10px;
                      font-size: 14px;
                    }
      
                    th {
                      background-color: #e2eefd;
                      text-align: left;
                    }
      
                    .footer {
                      text-align: center;
                      font-size: 12px;
                      color: #777;
                      margin-top: 20px;
                    }
      
                    @media print {
                      body {
                        background: white;
                        padding: 0;
                      }

                    }
                  </style>
                </head>
                <body>
                  <div class="receipt-container">
                    ${["Office Copy", "Student Copy"].map(copyType => `
                      <div class="receipt-box">
                        <div class="school-header">
                        <img src="${school.logo}" onerror="this.onerror=null;this.src='${school.defaultLogo}'" alt="School Logo" class="school-logo" />
                        
                        <div class="school-text">
                            <div class="school-name">${school.name}</div>
                            <div class="school-contact">
                                ${school.address ? school.address + "<br/>" : ""}
                                ${school.phone ? `Phone: ${school.phone} | ` : ""}
                                ${school.email ? `Email: ${school.email}` : ""}
                            </div>
                        </div>

                        </div>

      
                        <div class="header">Fee Receipt</div>
                        <div class="copy-label">${copyType}</div>
      
                        <div class="section-title">Student Details</div>
                        <div class="info-row single-row">
                          <p><strong>Student Name:</strong> ${data.student_name}</p>
                          <p><strong>Class:</strong> ${data.class_name} - ${data.section_name}</p>
                          <p><strong>Roll No:</strong> ${data.roll_no}</p>
                        </div>
      
                        <div class="section-title">Fee Details</div>
                        <table>
                          <thead>
                            <tr>
                              <th>Fee Type</th>
                              <th>Txn Id</th>
                              <th>Amount</th>
                              <th>Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>${data.fee_type}</td>
                              <td>${data.txn_id}</td>
                              <td>₹ ${data.amount}</td>
                              <td>${data.payment_status}</td>
                            </tr>
                          </tbody>
                        </table>

                        <div class="info-row single-row">
                          <p><strong>Payment Date:</strong> ${data.payment_date || '-'}</p>
                          <p><strong>Collected By:</strong> ${data.collected_by_name || '-'}</p>
                        </div>
      
                        <div class="footer">
                          This is a system-generated receipt and doesn't require signature.
                        </div>
                      </div>
                    `).join("")}
                  </div>
      
                  <script>
                    window.onload = function() {
                      window.print();
                    };
                    window.onafterprint = function () {
                        window.close();
                    };
                  </script>
                </body>
              </html>
            `);

                printWindow.document.close();
            } else {
                alert("Invoice not found.");
            }
        } catch (error) {
            console.error("Print error:", error);
            alert("Something went wrong while generating the invoice.");
        }
    };

    const handleThermalPrint = async (studentId, feeType, category, monthId = null) => {
        try {
            let res;

            if (category !== "monthly") {
                res = await api.get(`student-invoice/${studentId}/${feeType}/${filters.session?.id}`);
            } else {
                const finalMonthId = monthId
                    ? monthId
                    : (new Date().getMonth() + 1).toString().padStart(2, "0");

                const formattedMonth = getAcademicMonth(finalMonthId, filters.session);
                res = await api.get(`student-invoice/${studentId}/${formattedMonth}/${filters.session?.id}`);
            }

            if (res.data.status) {
                const data = res.data.data;
                const printWindow = window.open();

                // School Info Helper
                function getPrintSchoolInfo(apiData) {
                    const LOGO_BASE = "https://dgps.co.in/public/admin/assets/img/schools/logo";
                    const defaultLogo = "https://dgps.co.in/public/admin/assets/img/logo.png";

                    const resolveLogo = (logo) => {
                        if (!logo) return defaultLogo;
                        if (/^https?:\/\//i.test(logo) || logo.startsWith("data:")) return logo;
                        return `${LOGO_BASE}/${logo.replace(/^\/+/, "")}`;
                    };

                    if (apiData && (apiData.school_name || apiData.school_logo_bk)) {
                        return {
                            name: (apiData.school_name || "Dormant Garden Public School").toUpperCase(),
                            address: apiData.school_address || "",
                            phone: apiData.school_phone || "",
                            email: apiData.school_email || "",
                            logo: resolveLogo(apiData.school_logo_bk),
                            defaultLogo,
                        };
                    }

                    const sname = localStorage.getItem("school_name");
                    const slog = localStorage.getItem("school_logo_bk");
                    return {
                        name: (sname || "Dormant Garden Public School").toUpperCase(),
                        address: localStorage.getItem("school_address") || "",
                        phone: localStorage.getItem("school_phone") || "",
                        email: localStorage.getItem("school_email") || "",
                        logo: resolveLogo(slog),
                        defaultLogo,
                    };
                }

                const school = getPrintSchoolInfo(data);

                // 🧾 Final Professional Thermal Layout (Perfectly Aligned & Crisp)
                printWindow.document.write(`
        <html>
        <head>
          <title>Student Copy</title>
          <style>
            @page {
              size: 80mm auto;
              margin: 2mm;
            }

            body {
              width: 70mm;
              margin: 0 auto;
              padding: 2mm;
              font-family: 'Segoe UI', sans-serif;
              background: #ffffff;
              color: #000000;
              font-size: 12px;
              -webkit-print-color-adjust: exact !important;
              image-rendering: crisp-edges;
              image-rendering: pixelated;
            }

            .center { text-align: center; }
            .right { text-align: right; }
            .bold { font-weight: bold; }

            .line {
              border-bottom: 1px dashed #000000;
              margin: 3px 0;
            }

            .school-logo {
              width: 45px;
              height: 45px;
              display: block;
              margin: 0 auto 2px;
              object-fit: contain;
              image-rendering: pixelated;
            }

            .school-name {
              font-size: 12px;
              font-weight: bold;
              text-transform: uppercase;
              margin-bottom: 2px;
            }

            .contact {
              font-size: 10px;
              line-height: 1.2;
              margin-bottom: 4px;
            }

            .title-bar {
              text-align: center;
              font-weight: bold;
              font-size: 11px;
              background: #000000;
              color: #ffffff;
              padding: 2px 0;
              border-radius: 2px;
              margin: 4px 0;
            }

            .info-row {
              display: flex;
              justify-content: space-between;
              font-size: 11px;
              margin: 2px 0;
              word-wrap: break-word;
              width: 100%;
            }

            table {
              width: 100%;
              border-collapse: collapse;
              font-size: 11px;
              margin-top: 2px;
            }

            th, td {
              padding: 2px 0;
              text-align: left;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }

            th {
              border-bottom: 1px solid #000000;
            }

            td {
              border-bottom: 1px dotted #000000;
            }

            .footer {
              text-align: center;
              font-size: 9.5px;
              margin-top: 6px;
              border-top: 1px dashed #000000;
              padding-top: 3px;
              font-style: italic;
              line-height: 1.3;
            }

            @media print {
              body {
                -webkit-print-color-adjust: exact !important;
              }
            }
          </style>
        </head>
        <body>
          <div class="center">
            <img src="${school.logo}" onerror="this.onerror=null;this.src='${school.defaultLogo}'" class="school-logo" />
            <div class="school-name">${school.name}</div>
            <div class="contact">
              ${school.address ? `${school.address}<br/>` : ""}
              ${school.phone ? `Ph: ${school.phone}<br/>` : ""}
              ${school.email ? `${school.email}` : ""}
            </div>
          </div>

          <div class="title-bar">STUDENT COPY - FEE RECEIPT</div>

          <div class="info-row"><span>Student:</span><span>${data.student_name}</span></div>
          <div class="info-row"><span>Class:</span><span>${data.class_name}-${data.section_name}</span></div>
          <div class="info-row"><span>Roll No:</span><span>${data.roll_no}</span></div>

          <div class="line"></div>
          <table>
            <thead>
              <tr>
                <th>Fee Type</th>
                <th>Txn ID</th>
                <th class="right">Amt</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>${data.fee_type}</td>
                <td>${data.txn_id}</td>
                <td class="right">₹${data.amount}</td>
              </tr>
            </tbody>
          </table>

          <div class="info-row"><span>Date:</span><span>${data.payment_date || "-"}</span></div>
          <div class="info-row"><span>Collected By:</span><span>${data.collected_by_name || "-"}</span></div>

          <div class="line"></div>
          <div class="footer">
            Thank you for your payment!<br/>
            This is a system-generated receipt.<br/>
            No signature required.
          </div>

          <script>
            window.onload = function() {
              window.print();
            };
            window.onafterprint = function() {
              window.close();
            };
          </script>
        </body>
        </html>
      `);

                printWindow.document.close();
            } else {
                alert("Invoice not found.");
            }
        } catch (error) {
            console.error("Thermal print error:", error);
            alert("Something went wrong while generating the thermal invoice.");
        }
    };


    useEffect(() => {
        const fetchClasses = async () => {
            try {
                const res = await api.get("/get-classes");

                if (res.data && res.data.success) {
                    setClassList(res.data.data); // backend e data array ache
                } else {
                    setClassList([]);
                    console.warn("Unexpected response:", res.data);
                }
            } catch (error) {
                setClassList([]);
                console.error("Error fetching classes:", error);
            }
        };

        fetchClasses();
    }, []);

    useEffect(() => {
        const fetchSection = async () => {
            try {
                const res = await api.get(`/get-sections/${selectedClass}`);

                if (res.data && res.data.success) {
                    setSections(res.data.data); // backend e data array ache
                } else {
                    setSections([]);
                    console.warn("Unexpected response:", res.data);
                }
            } catch (error) {
                setSections([]);
                console.error("Error fetching classes:", error);
            }
        };

        fetchSection();
    }, [selectedClass]);

    useEffect(() => {
        const fetchRoll = async () => {
            try {
                const res = await api.get(`/get-rolls/${selectedSection}`);

                if (res.data && res.data.success) {
                    // ✅ remove duplicate roll_no
                    const uniqueRolls = Array.from(
                        new Map(
                            res.data.data.map((r) => [r.roll_no, r])
                        ).values()
                    );

                    setRolls(uniqueRolls);
                    setSelectedRoll("");
                } else {
                    setRolls([]);
                }
            } catch (error) {
                setRolls([]);
                console.error("Error fetching rolls:", error);
            }
        };

        if (selectedSection) fetchRoll();
    }, [selectedSection]);



    // ✅ Optimized handleSearch Function
    const handleSearch = async () => {
        try {
            const params = {};

            if (filters.session) params.academic_year_id = filters.session.id;
            if (searchTerm) params.query = searchTerm;
            if (selectedClass) params.class_id = selectedClass;
            if (selectedSection) params.section_id = selectedSection;
            if (selectedRoll) params.roll_no = selectedRoll;

            const res = await api.get("/search_student", { params });
            const data = res.data;
            if (data?.status && Array.isArray(data.students) && data.students.length > 0) {
                const s = data.students[0];
                setStudent(s);
                setPayments(s.payments || []);

                const combined = [
                    ...(s.yearly_fees || []).map(f => ({ ...f, category: "yearly" })),
                    ...(s.monthly_fees || []).map(f => ({ ...f, category: "monthly" }))
                ];
                setFees(combined);

                // map paid fees: monthly payments become monthly_fees_<monthIndex>
                const mappedPaid = (s.payments || []).map(p => {
                    if (p.fee_type === "monthly_fees" && p.payment_status === "paid") {
                        const monthPart = p.payment_month ? String(p.payment_month).split("-")[1] : null;
                        const monthIndex = monthPart ? parseInt(monthPart, 10) : NaN;
                        if (!isNaN(monthIndex) && monthIndex >= 1 && monthIndex <= 12) {
                            return `monthly_fees_${monthIndex}`;
                        }
                        return `monthly_fees_unknown_${p.id || Math.random()}`;
                    }
                    return String(p.fee_type ?? p.id ?? "");
                });
                setPaidFees(mappedPaid);
            } else {
                setStudent(null);
                setPayments([]);
                setFees([]);
                setPaidFees([]);
            }
        } catch (err) {
            console.error("search-student error:", err?.response || err);
            // if 401 --> backend auth issue; show message
            if (err?.response?.status === 401) {
                Swal.fire({ icon: "error", title: "Unauthorized", text: "Session expired or invalid token. Please login again." }).then(() => {
                    localStorage.clear();
                    window.location.href = "/login";
                });
            }
        }
    };

    useEffect(() => {
        console.log("Paid Fees Mapping: ", paidFees);
    }, [paidFees]);


    // ✅ মাসের নামগুলোর জন্য গ্লোবাল অ্যারে (ফাংশনের বাইরে ডিক্লেয়ার করা)
    const months = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];

    // ✅ `useEffect` to Update `filteredFees` (Optimize and Clean)
    useEffect(() => {
        let updatedFees = fees.filter(fee => fee.category !== "monthly");

        if (student?.monthly_payment > 0) {
            let monthlyFees = months.map((month, index) => {
                const feeId = `monthly_fees_${index + 1}`;
                return {
                    id: feeId,
                    fee_type: `Monthly Fees - ${month}`,
                    amount: student.monthly_payment,
                    category: "monthly",
                    isPaid: paidFees.includes(feeId),
                };
            });

            updatedFees = [...updatedFees, ...monthlyFees];
        }

        setFilteredFees(updatedFees);
        console.log("update fees", updatedFees);
    }, [fees, student, paidFees]); // ✅ Add `paidFees` dependency here


    // ✅ Simplified Check if Fee is Paid
    const checkIfPaid = (fee) => {
        return paidFees.includes(fee.id);  // ✅ Checking the fee ID directly
    };



    return (
        <div style={{ display: "flex", flexDirection: "column", height: "100vh", marginTop: "0px" }}>
            <div style={{ display: "flex", flex: 1 }}>
                <div className="p-5" style={{ flex: 1, margin: "5px" }}>

                    {/* Filter Section */}
                    <Paper elevation={4} style={{
                        padding: "20px",
                        borderRadius: "12px",
                        background: "#f9f9f9",
                        marginBottom: "10px"
                    }}>
                        <Grid container spacing={2}>

                            <Grid item xs={3}>
                                <Autocomplete
                                    options={sessions}
                                    getOptionLabel={(opt) =>
                                        `${opt.session_name || ""}${opt.status ? ` (${opt.status})` : ""}`
                                    }
                                    value={filters.session}
                                    onChange={(_, v) => setFilters((p) => ({ ...p, session: v }))}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Select Session" fullWidth />
                                    )}
                                    clearOnEscape
                                />
                            </Grid>

                            <Grid item xs={3}>
                                <Autocomplete
                                    options={classList}
                                    getOptionLabel={(option) => option.class_name}
                                    value={classList.find((cls) => cls.id === selectedClass) || null}
                                    onChange={(event, newValue) => {
                                        setSelectedClass(newValue ? newValue.id : "");
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Select Class"
                                            fullWidth
                                            InputProps={{
                                                ...params.InputProps,
                                                endAdornment: (
                                                    <>
                                                        {selectedClass && (
                                                            <IconButton
                                                                onClick={() => setSelectedClass("")}
                                                                edge="end"
                                                                size="small"
                                                            >
                                                            </IconButton>
                                                        )}
                                                        {params.InputProps.endAdornment}
                                                    </>
                                                ),
                                            }}
                                        />
                                    )}
                                />
                            </Grid>

                            {/* Section Selection */}
                            <Grid item xs={3}>
                                <Autocomplete
                                    options={selectedClass ? sections : []}
                                    getOptionLabel={(option) => option.section_name}
                                    value={sections.find((sec) => sec.id === selectedSection) || null}
                                    onChange={(event, newValue) => {
                                        setSelectedSection(newValue ? newValue.id : "");
                                    }}
                                    disabled={!selectedClass}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Select Section"
                                            fullWidth
                                            disabled={!selectedClass}
                                            InputProps={{
                                                ...params.InputProps,
                                                endAdornment: (
                                                    <>
                                                        {selectedSection && (
                                                            <IconButton
                                                                onClick={() => setSelectedSection("")}
                                                                edge="end"
                                                                size="small"
                                                            >
                                                            </IconButton>
                                                        )}
                                                        {params.InputProps.endAdornment}
                                                    </>
                                                ),
                                            }}
                                        />
                                    )}
                                />
                            </Grid>

                            {/* Roll Number Selection */}
                            <Grid item xs={3}>
                                <Autocomplete
                                    options={selectedSection ? rolls : []}
                                    getOptionLabel={(option) => option.roll_no} // Convert to string
                                    value={rolls.find((roll) => roll.roll_no === selectedRoll) || null}
                                    onChange={(event, newValue) => {
                                        setSelectedRoll(newValue ? newValue.roll_no : "");
                                    }}
                                    disabled={!selectedSection}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Select Roll Number"
                                            fullWidth
                                            disabled={!selectedSection}
                                            InputProps={{
                                                ...params.InputProps,
                                                endAdornment: (
                                                    <>
                                                        {selectedRoll && (
                                                            <IconButton
                                                                onClick={() => setSelectedRoll("")}
                                                                edge="end"
                                                                size="small"
                                                            >
                                                            </IconButton>
                                                        )}
                                                        {params.InputProps.endAdornment}
                                                    </>
                                                ),
                                            }}
                                        />
                                    )}
                                />
                            </Grid>

                            <Grid item xs={4}>
                                <TextField
                                    fullWidth
                                    label="Search (Name, Mobile, ID)"
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    InputProps={{
                                        endAdornment: (
                                            <>
                                                {searchTerm && (
                                                    <IconButton
                                                        onClick={() => setSearchTerm("")}
                                                        edge="end"
                                                        size="small"
                                                    >
                                                        <ClearIcon />
                                                    </IconButton>
                                                )}
                                            </>
                                        ),
                                    }}
                                />
                            </Grid>
                            <Grid item xs={4} style={{ display: "flex", justifyContent: "center" }}>
                                <Button
                                    variant="contained"
                                    onClick={handleSearch}
                                    startIcon={<SearchIcon />}
                                    style={{
                                        background: "linear-gradient(90deg, #4e54c8 0%, #8f94fb 100%)",
                                        color: "#fff",
                                        padding: "12px 30px",
                                        fontSize: "16px",
                                        fontWeight: "600",
                                        borderRadius: "12px",
                                        textTransform: "none",
                                        boxShadow: "0 8px 16px rgba(78, 84, 200, 0.3)",
                                        transition: "transform 0.2s ease, box-shadow 0.2s ease",
                                    }}
                                    onMouseOver={(e) => {
                                        e.currentTarget.style.transform = "scale(1.05)";
                                        e.currentTarget.style.boxShadow = "0 12px 20px rgba(78, 84, 200, 0.5)";
                                    }}
                                    onMouseOut={(e) => {
                                        e.currentTarget.style.transform = "scale(1)";
                                        e.currentTarget.style.boxShadow = "0 8px 16px rgba(78, 84, 200, 0.3)";
                                    }}
                                >
                                    Search Student
                                </Button>
                            </Grid>
                        </Grid>
                    </Paper>

                    {/* Student Details & Fees */}
                    <Grid container spacing={2}>
                        {/* Student Details Section */}
                        <Grid item xs={12} sm={12} md={4}>
                            <Paper elevation={4} style={{ padding: "20px", borderRadius: "12px", background: "#f9f9f9" }}>
                                <Typography variant="h6" gutterBottom style={{ fontWeight: "bold", textAlign: "center", color: "#333", borderBottom: "2px solid #3f51b5", paddingBottom: "8px", marginBottom: "10px" }}>
                                    🎓 Student Details
                                </Typography>

                                {student?.file ? (
                                    <div style={{ display: "flex", justifyContent: "center", marginBottom: "15px" }}>
                                        <img
                                            src={student.file}
                                            alt="Student"
                                            style={{
                                                width: "120px",
                                                height: "120px",
                                                borderRadius: "50%",
                                                objectFit: "cover",
                                                border: "2px solid #3f51b5",
                                            }}
                                        />
                                    </div>
                                ) : (
                                    <div style={{ textAlign: "center", marginBottom: "15px", color: "#888" }}>
                                        <Typography variant="body2" style={{ fontStyle: "italic" }}>
                                            No Photo Available
                                        </Typography>
                                    </div>
                                )}

                                {student ? (

                                    <div style={{ display: "grid", gap: "8px" }}>
                                        {renderDetail("🆔 Student ID", student.student_code)}
                                        {renderDetail("👤 Name", student.name)}
                                        {renderDetail("🏫 Class", student.class)}
                                        {renderDetail("📚 Section", student.section)}
                                        {renderDetail("🔢 Roll No", student.roll_no)}
                                        {renderDetail("📞 Mobile", student.mobile)}
                                    </div>
                                ) : (
                                    <Typography variant="body1" style={{ textAlign: "center", color: "#777", fontStyle: "italic", paddingTop: "10px" }}>
                                        No Student Selected
                                    </Typography>
                                )}
                            </Paper>
                        </Grid>

                        {/* Fee Details Section */}
                        <Grid item xs={12} sm={12} md={8}>

                            <Paper elevation={4} style={{ padding: "20px", borderRadius: "12px", background: "#f9f9f9" }}>
                                <Typography
                                    variant="h6"
                                    style={{
                                        fontWeight: "bold",
                                        textAlign: "center",
                                        color: "#333",
                                        borderBottom: "2px solid #3f51b5",
                                        paddingBottom: "8px",
                                        marginBottom: "15px",
                                    }}
                                >
                                    💰 Fee Details
                                </Typography>

                                {filteredFees.length > 0 ? (
                                    <>
                                        {/* ✅ প্রথম Row - Regular Fees */}
                                        <Grid container spacing={2}>
                                            {filteredFees
                                                .filter(fee => fee.category !== "monthly") // ✅ Regular Fees filter
                                                .map((fee) => {
                                                    const isPaid = checkIfPaid(fee);

                                                    return (
                                                        <Grid item xs={12} sm={6} md={3} key={fee.id}>
                                                            <Paper
                                                                elevation={2}
                                                                style={{
                                                                    padding: "20px",
                                                                    borderRadius: "16px",
                                                                    textAlign: "center",
                                                                    background: isPaid ? "linear-gradient(135deg, #e0f2f1, #e8f5e9)" : "#ffffff",
                                                                    border: isPaid ? "1px solid #81c784" : "1px solid #e0e0e0",
                                                                    boxShadow: isPaid
                                                                        ? "0 8px 20px rgba(129, 199, 132, 0.3)"
                                                                        : "0 6px 12px rgba(0, 0, 0, 0.06)",
                                                                    transition: "all 0.3s ease-in-out",
                                                                    backdropFilter: "blur(4px)",
                                                                    WebkitBackdropFilter: "blur(4px)",
                                                                }}
                                                            >
                                                                <Typography variant="body1" style={{ fontWeight: "bold", color: "#333" }}>
                                                                    {fee.fee_type}
                                                                </Typography>
                                                                <Typography variant="h6" style={{ color: "#3f51b5", margin: "5px 0" }}>
                                                                    ₹ {fee.amount}
                                                                </Typography>
                                                                {isPaid ? (
                                                                    <div
                                                                        style={{
                                                                            display: "flex",
                                                                            flexDirection: "column",
                                                                            alignItems: "center",
                                                                            justifyContent: "center",
                                                                            marginTop: "0px",
                                                                        }}
                                                                    >
                                                                        {/* ✅ Icon + Text */}
                                                                        <div
                                                                            style={{
                                                                                display: "flex",
                                                                                flexDirection: "column",
                                                                                alignItems: "center",
                                                                                justifyContent: "center",
                                                                                backgroundColor: "#E8F5E9",
                                                                                borderRadius: "50%",
                                                                                boxShadow: "0 3px 8px rgba(76, 175, 80, 0.25)",
                                                                            }}
                                                                        >
                                                                            <CheckCircleIcon style={{ color: "#2e7d32", fontSize: 28 }} />
                                                                        </div>

                                                                        {/* Buttons Row */}
                                                                        <div
                                                                            style={{
                                                                                display: "flex",
                                                                                justifyContent: "center",
                                                                                gap: "10px",
                                                                                marginTop: "12px",
                                                                            }}
                                                                        >
                                                                            {/* 🖨️ Normal Print Button */}
                                                                            <Button
                                                                                variant="contained"
                                                                                size="small"
                                                                                startIcon={<PrintIcon />}
                                                                                onClick={() => handlePrint(student.id, fee.id, fee.category)}
                                                                                style={{
                                                                                    borderRadius: "10px",
                                                                                    fontWeight: 600,
                                                                                    padding: "8px 18px",
                                                                                    color: "#fff",
                                                                                    background: "linear-gradient(90deg, #43a047, #2e7d32)",
                                                                                    boxShadow: "0 4px 10px rgba(46, 125, 50, 0.3)",
                                                                                    transition: "all 0.25s ease",
                                                                                    textTransform: "none",
                                                                                }}
                                                                                onMouseOver={(e) => {
                                                                                    e.currentTarget.style.transform = "scale(1.05)";
                                                                                    e.currentTarget.style.boxShadow = "0 8px 16px rgba(46, 125, 50, 0.45)";
                                                                                }}
                                                                                onMouseOut={(e) => {
                                                                                    e.currentTarget.style.transform = "scale(1)";
                                                                                    e.currentTarget.style.boxShadow = "0 4px 10px rgba(46, 125, 50, 0.3)";
                                                                                }}
                                                                            >
                                                                                Print
                                                                            </Button>

                                                                            {/* 🧾 Thermal Print Button */}
                                                                            <Button
                                                                                variant="contained"
                                                                                size="small"
                                                                                startIcon={<PrintIcon />}
                                                                                onClick={() => handleThermalPrint(student.id, fee.id, fee.category)}
                                                                                style={{
                                                                                    borderRadius: "10px",
                                                                                    fontWeight: 600,
                                                                                    padding: "8px 18px",
                                                                                    color: "#fff",
                                                                                    background: "linear-gradient(90deg, #1b5e20, #388e3c)",
                                                                                    boxShadow: "0 4px 10px rgba(27, 94, 32, 0.35)",
                                                                                    transition: "all 0.25s ease",
                                                                                    textTransform: "none",
                                                                                }}
                                                                                onMouseOver={(e) => {
                                                                                    e.currentTarget.style.transform = "scale(1.05)";
                                                                                    e.currentTarget.style.boxShadow = "0 8px 16px rgba(27, 94, 32, 0.45)";
                                                                                }}
                                                                                onMouseOut={(e) => {
                                                                                    e.currentTarget.style.transform = "scale(1)";
                                                                                    e.currentTarget.style.boxShadow = "0 4px 10px rgba(27, 94, 32, 0.35)";
                                                                                }}
                                                                            >
                                                                                Thermal Print
                                                                            </Button>
                                                                        </div>
                                                                    </div>
                                                                ) : (
                                                                    <Button
                                                                        variant="contained"
                                                                        color="primary"
                                                                        size="small"
                                                                        onClick={() => handleOpenModal(fee, student)}
                                                                        startIcon={<PaymentIcon />}
                                                                        style={{
                                                                            borderRadius: "10px",
                                                                            fontWeight: 600,
                                                                            padding: "8px 22px",
                                                                            background: "linear-gradient(90deg, #1565c0, #1976d2)",
                                                                            boxShadow: "0 4px 10px rgba(25, 118, 210, 0.3)",
                                                                            marginTop: "12px",
                                                                            transition: "all 0.25s ease",
                                                                            textTransform: "none",
                                                                        }}
                                                                        onMouseOver={(e) => {
                                                                            e.currentTarget.style.transform = "scale(1.05)";
                                                                            e.currentTarget.style.boxShadow = "0 8px 16px rgba(25, 118, 210, 0.45)";
                                                                        }}
                                                                        onMouseOut={(e) => {
                                                                            e.currentTarget.style.transform = "scale(1)";
                                                                            e.currentTarget.style.boxShadow = "0 4px 10px rgba(25, 118, 210, 0.3)";
                                                                        }}
                                                                    >
                                                                        Pay Now
                                                                    </Button>
                                                                )}


                                                            </Paper>
                                                        </Grid>
                                                    );
                                                })}
                                        </Grid>

                                        {/* ✅ দ্বিতীয় Row - Monthly Fees */}
                                        <Typography
                                            variant="h6"
                                            style={{
                                                fontWeight: "bold",
                                                textAlign: "center",
                                                color: "#3f51b5",
                                                borderBottom: "2px solid #3f51b5",
                                                paddingBottom: "8px",
                                                marginBottom: "15px",
                                            }}
                                        >
                                            📆 Monthly Fees
                                        </Typography>

                                        <Grid container spacing={2}>
                                            {filteredFees
                                                .filter(fee => fee.category === "monthly") // ✅ Monthly Fees filter
                                                .map((fee) => {
                                                    const isPaid = checkIfPaid(fee);

                                                    let monthId = "00"; // Default value
                                                    const monthIndex = months.findIndex(m => fee.fee_type.includes(m));
                                                    if (monthIndex !== -1) {
                                                        monthId = String(monthIndex + 1).padStart(2, "0");
                                                    }

                                                    return (
                                                        <Grid item xs={12} sm={6} md={3} key={fee.id}>
                                                            <Paper
                                                                elevation={2}
                                                                style={{
                                                                    padding: "20px",
                                                                    borderRadius: "16px",
                                                                    textAlign: "center",
                                                                    //minHeight: "100px",
                                                                    background: isPaid ? "linear-gradient(135deg, #e0f2f1, #e8f5e9)" : "#ffffff",
                                                                    border: isPaid ? "1px solid #81c784" : "1px solid #e0e0e0",
                                                                    boxShadow: isPaid
                                                                        ? "0 8px 20px rgba(129, 199, 132, 0.3)"
                                                                        : "0 6px 12px rgba(0, 0, 0, 0.06)",
                                                                    transition: "all 0.3s ease-in-out",
                                                                    backdropFilter: "blur(4px)",
                                                                    WebkitBackdropFilter: "blur(4px)",
                                                                }}
                                                            >
                                                                <Typography variant="body1" style={{ fontWeight: "bold", color: "#333" }}>
                                                                    {fee.fee_type}
                                                                </Typography>
                                                                <Typography variant="h6" style={{ color: "#3f51b5", margin: "5px 0" }}>
                                                                    ₹ {fee.amount}
                                                                </Typography>


                                                                {isPaid ? (
                                                                    <div
                                                                        style={{
                                                                            display: "flex",
                                                                            flexDirection: "column",
                                                                            alignItems: "center",
                                                                            justifyContent: "center",
                                                                            marginTop: "0px",
                                                                        }}
                                                                    >
                                                                        {/* ✅ Icon + Text */}
                                                                        <div
                                                                            style={{
                                                                                display: "flex",
                                                                                flexDirection: "column",
                                                                                alignItems: "center",
                                                                                justifyContent: "center",
                                                                                backgroundColor: "#E8F5E9",
                                                                                borderRadius: "50%",
                                                                                boxShadow: "0 3px 8px rgba(76, 175, 80, 0.25)",
                                                                            }}
                                                                        >
                                                                            <CheckCircleIcon style={{ color: "#2e7d32", fontSize: 28 }} />
                                                                        </div>

                                                                        {/* Buttons Row */}
                                                                        <div
                                                                            style={{
                                                                                display: "flex",
                                                                                justifyContent: "center",
                                                                                gap: "10px",
                                                                                marginTop: "12px",
                                                                            }}
                                                                        >
                                                                            {/* 🖨️ Normal Print Button */}
                                                                            <Button
                                                                                variant="contained"
                                                                                size="small"
                                                                                startIcon={<PrintIcon />}
                                                                                onClick={() => handlePrint(student.id, fee.id, fee.category, monthId)}
                                                                                style={{
                                                                                    borderRadius: "10px",
                                                                                    fontWeight: 600,
                                                                                    padding: "8px 18px",
                                                                                    color: "#fff",
                                                                                    background: "linear-gradient(90deg, #43a047, #2e7d32)",
                                                                                    boxShadow: "0 4px 10px rgba(46, 125, 50, 0.3)",
                                                                                    transition: "all 0.25s ease",
                                                                                    textTransform: "none",
                                                                                }}
                                                                                onMouseOver={(e) => {
                                                                                    e.currentTarget.style.transform = "scale(1.05)";
                                                                                    e.currentTarget.style.boxShadow = "0 8px 16px rgba(46, 125, 50, 0.45)";
                                                                                }}
                                                                                onMouseOut={(e) => {
                                                                                    e.currentTarget.style.transform = "scale(1)";
                                                                                    e.currentTarget.style.boxShadow = "0 4px 10px rgba(46, 125, 50, 0.3)";
                                                                                }}
                                                                            >
                                                                                Print
                                                                            </Button>

                                                                            {/* 🧾 Thermal Print Button */}
                                                                            <Button
                                                                                variant="contained"
                                                                                size="small"
                                                                                startIcon={<PrintIcon />}
                                                                                onClick={() => handleThermalPrint(student.id, fee.id, fee.category, monthId)}
                                                                                style={{
                                                                                    borderRadius: "10px",
                                                                                    fontWeight: 600,
                                                                                    padding: "8px 18px",
                                                                                    color: "#fff",
                                                                                    background: "linear-gradient(90deg, #1b5e20, #388e3c)",
                                                                                    boxShadow: "0 4px 10px rgba(27, 94, 32, 0.35)",
                                                                                    transition: "all 0.25s ease",
                                                                                    textTransform: "none",
                                                                                }}
                                                                                onMouseOver={(e) => {
                                                                                    e.currentTarget.style.transform = "scale(1.05)";
                                                                                    e.currentTarget.style.boxShadow = "0 8px 16px rgba(27, 94, 32, 0.45)";
                                                                                }}
                                                                                onMouseOut={(e) => {
                                                                                    e.currentTarget.style.transform = "scale(1)";
                                                                                    e.currentTarget.style.boxShadow = "0 4px 10px rgba(27, 94, 32, 0.35)";
                                                                                }}
                                                                            >
                                                                                Thermal Print
                                                                            </Button>
                                                                        </div>
                                                                    </div>
                                                                ) : (
                                                                    <Button
                                                                        variant="contained"
                                                                        color="primary"
                                                                        size="small"
                                                                        onClick={() => handleOpenModal(fee, student, monthId)}
                                                                        startIcon={<PaymentIcon />}
                                                                        style={{
                                                                            borderRadius: "10px",
                                                                            fontWeight: 600,
                                                                            padding: "8px 22px",
                                                                            background: "linear-gradient(90deg, #1565c0, #1976d2)",
                                                                            boxShadow: "0 4px 10px rgba(25, 118, 210, 0.3)",
                                                                            marginTop: "12px",
                                                                            transition: "all 0.25s ease",
                                                                            textTransform: "none",
                                                                        }}
                                                                        onMouseOver={(e) => {
                                                                            e.currentTarget.style.transform = "scale(1.05)";
                                                                            e.currentTarget.style.boxShadow = "0 8px 16px rgba(25, 118, 210, 0.45)";
                                                                        }}
                                                                        onMouseOut={(e) => {
                                                                            e.currentTarget.style.transform = "scale(1)";
                                                                            e.currentTarget.style.boxShadow = "0 4px 10px rgba(25, 118, 210, 0.3)";
                                                                        }}
                                                                    >
                                                                        Pay Now
                                                                    </Button>
                                                                )}
                                                            </Paper>
                                                        </Grid>
                                                    );
                                                })}
                                        </Grid>
                                    </>
                                ) : (
                                    <Typography
                                        variant="body1"
                                        style={{ textAlign: "center", color: "#777", fontStyle: "italic", paddingTop: "10px" }}
                                    >
                                        No Fees Available
                                    </Typography>
                                )}
                            </Paper>

                            {/* Payment Modal */}
                            <Modal open={openModal} onClose={handleCloseModal}>
                                <Box style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", width: 400, backgroundColor: "white", boxShadow: 24, padding: "20px", borderRadius: "10px", textAlign: "center" }}>
                                    {/* Close Button */}
                                    <IconButton
                                        onClick={handleCloseModal}
                                        style={{
                                            position: "absolute",
                                            top: "10px",
                                            right: "10px",
                                            color: "#555",
                                        }}
                                    >
                                        <CloseIcon />
                                    </IconButton>
                                    <Typography variant="h6" gutterBottom>Confirm Payment</Typography>

                                    {selectedFee && (
                                        <>
                                            <Typography variant="body1">
                                                <strong>Fee Type:</strong> {selectedFee.fee_type}
                                            </Typography>

                                            {selectedFee.fee_type === "MEAL CHARGE" ? (
                                                <>
                                                    <TextField
                                                        label="Total Days"
                                                        type="number"
                                                        fullWidth
                                                        value={totalDays}
                                                        onChange={(e) => setTotalDays(e.target.value)}
                                                        margin="normal"
                                                    />
                                                    <Typography variant="body1">
                                                        <strong>Rate per Day:</strong> ₹ {selectedFee.amount}
                                                    </Typography>
                                                    <Typography variant="h6" color="primary" style={{ margin: "10px 0" }}>
                                                        ₹ {totalDays * selectedFee.amount}
                                                    </Typography>
                                                </>
                                            ) : (
                                                <Typography variant="h6" color="primary" style={{ margin: "10px 0" }}>
                                                    ₹ {selectedFee.amount}
                                                </Typography>
                                            )}

                                            <TextField
                                                select
                                                label="Payment Mode"
                                                fullWidth
                                                value={paymentMode}
                                                onChange={(e) => setPaymentMode(e.target.value)}
                                                margin="normal"
                                                InputProps={{
                                                    endAdornment: paymentMode ? (
                                                        <InputAdornment position="end">
                                                            <IconButton
                                                                onClick={() => setPaymentMode("")}
                                                                edge="end"
                                                                size="small"
                                                            >
                                                                <ClearIcon fontSize="small" />
                                                            </IconButton>
                                                        </InputAdornment>
                                                    ) : null,
                                                }}
                                            >
                                                <MenuItem value="cash">Cash</MenuItem>
                                                <MenuItem value="upi">UPI</MenuItem>
                                            </TextField>

                                            {paymentMode === "upi" && (
                                                <TextField label="UTR Number" fullWidth value={utrNumber} onChange={(e) => setUtrNumber(e.target.value)} margin="normal" />
                                            )}

                                            <Button
                                                variant="contained"
                                                color="success"
                                                fullWidth
                                                onClick={handleSubmit}
                                                disabled={!paymentMode || isSubmitting} // 🔒 prevent double-click
                                            >
                                                {isSubmitting ? "Processing..." : "Proceed to Pay"}
                                                
                                            </Button>

                                        </>
                                    )}
                                </Box>
                            </Modal>

                        </Grid>
                    </Grid>
                </div>
            </div>
        </div>
    );
};

export default StudentBill;

const renderDetail = (label, value) => (
    <div style={{
        display: "flex",
        justifyContent: "space-between",
        background: "#fff",
        padding: "8px 12px",
        borderRadius: "8px",
        boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
        fontSize: "14px"
    }}>
        <Typography variant="body2" style={{ fontWeight: "bold", color: "#444" }}>
            {label}:
        </Typography>
        <Typography variant="body2" style={{ color: "#222", fontWeight: "600" }}>
            {value}
        </Typography>
    </div>
);


